import { Link, useMatchRoute } from "@tanstack/react-router"
import { Building2, Inbox } from "lucide-react"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/ui/components/ui/sidebar"
import { useT } from "@/i18n"

/**
 * Admin-area navigation (product.md §9.1): Submissions / Tenants. The
 * Account/Logout footer stays with the shared FooterMenu; there is no
 * workspace switcher in admin mode.
 */
export default function AdminNav() {
  const { t } = useT("admin")
  const matchRoute = useMatchRoute()

  const items = [
    {
      to: "/admin/submissions",
      icon: <Inbox />,
      label: t("nav.submissions"),
    },
    {
      to: "/admin/tenants",
      icon: <Building2 />,
      label: t("nav.tenants"),
    },
  ] as const

  return (
    <SidebarMenu>
      {items.map(({ to, icon, label }) => (
        <SidebarMenuItem key={to}>
          <SidebarMenuButton
            isActive={!!matchRoute({ to, fuzzy: true })}
            render={
              <Link to={to}>
                {icon}
                {label}
              </Link>
            }
          />
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  )
}
